import React from 'react'


export default function (props) {
  return (
    <div id="Authentication" className="d-flex justify-content-center align-items-center full-container">
      {props.children}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/containers/Authentication/index.js